import {templateToString} from '../util.js';

export const imgLoader = function(){
    let v = templateToString(arguments);
    return p=>new Promise((resolve, reject)=>p.loadImage(v, resolve, reject));
};

export const fontLoader = function(){
    let v = templateToString(arguments);
    return p=>new Promise((resolve, reject)=>p.loadFont(v, resolve, reject));
};

export const loadAssets = async (p, assets, data)=>{
    
};

export class SceneDirector {
    constructor(p){
        this.p = p;
        this.scene = null;
    }
    setScene(scene){
        this.scene?.destroy?.(this.p, this);
        scene.setup?.(this.p, this);
        this.scene = scene;
    }
    draw(){
        this.scene?.draw?.(this.p, this);
    }
    mousePressed(){
        this.scene?.mousePressed?.(this.p, this);
    }
}

